<template>
  <div class="page-systems">

    <SystemsPage v-if="gotIt || (property.active && property.cultSwitch_id !== null)"/>

    <BookingEngineDisabled
      v-else-if="!gotIt || (!property.active || property.cultSwitch_id === null)"
      @gotItEvent="gotItClick"
    />

  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import SystemsPage from '@/components/Pages/Connectivity/SystemsPage.vue';
  import BookingEngineDisabled from '@/components/Pages/Connectivity/BookingEngineDisabled.vue';
  /* eslint-disable vue/multi-word-component-names */
  export default {
    name: 'Systems',
    components: {
      SystemsPage,
      BookingEngineDisabled,
    },
    data() {
      return {
        gotIt: false,
      };
    },
    computed: {
      ...mapGetters('user', ['property']),
    },
    methods: {
      gotItClick() {
        this.gotIt = true;
      },
    },
  };
</script>
